﻿export interface IRccapPositionDetailRequest {
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    responsibleCenter: number;
    donorId: number;
    donorAlias: string;
    donorCenterId: number;
    recipientId: number;
    recipientAlias: string;
    recipientAbo: string;
    recipientPmpC: number;
    recipientCpra: number;
    recipientDonorAbo: string;
    recipientCenterId: number;
    rccapManager: number;
    transplantsImpacted: number;
    exmRequestedDate: string;
    failDate: string;
    targetSurgeryDate: string;
    dueDate: string;
    matchOfferDate: string;
    issueDescription: string;
    additionalQuestions: string[];
    rootCausePrimary: number;
    rootCauseSecondary: number;
    acceptedResponse: string;
    additionalComments: string;
    avoidable: number;
    billable: number;
    satisfactoryResponse: number;
    centerCorrectiveAction: string;
    responder: string;
    responseDate: string;
    correctiveActionPrimary: number;
    correctiveActionSecondary: number;
    rccapPhase: number;
    requester: number;
    currentStatus: number;
    wasSwapCancelled: boolean;
}
